import React from "react";
import "./starrybackground.css";

const StarryBackground = () => {
  const numStars = 300;
  return (
    <div className="star_wrap">
      <div className="starry-background">
        {[...Array(numStars)].map((_, index) => (
          <div
            key={index}
            className="star"
            style={{
              animationDelay: `${Math.random() * 5}s`,
              animationDuration: `${Math.random() * 1 + 2}s`,
              left: `${Math.random() * 100}vw`,
              top: `${Math.random() * 100}vh`,
            }}
          ></div>
        ))}
      </div>
    </div>
  );
};

export default StarryBackground;
